import CancelIcon from "@mui/icons-material/Cancel";
import { grey } from "@mui/material/colors";
import { IExpense } from "Dashboard/scenes/Expenses/domain/IExpense";
import { useAppDispatch } from "hooks/hooks";
import { toast } from "react-toastify";
import { FormatDate } from "utils/dateUtils";
import { setDeleteExpenseModalOpen, setSelectedIndex, updateExpense } from "../main.slice";
import ProjectSelect from "Dashboard/scenes/Projects/components/ProjectSelect";
import { styles } from "../../../../../../components/Popover/popoverSelectStyle";
import { debounce } from "lodash";
import { IProjectOption } from "Dashboard/domain/IProjectOption";

interface IProps {
  expense: IExpense;
  index: number;
  projects: IProjectOption[];
}

const TableRow = ({ expense, index, projects }: IProps) => {
  const dispatch = useAppDispatch();

  const onChangeTitle = debounce(async (expenseId, titleValue) => {
    try {
      await dispatch(updateExpense({ expenseId, data: { title: titleValue } }));
      toast.success("Naziv troška je uspešno izmenjen.");
    } catch (err) {
      console.error("Error updating expense title:", err);
    }
  }, 1000);

  const handleProjectChange = debounce(async (projectId: number) => {
    try {
      await dispatch(updateExpense({ expenseId: expense.expenseId, data: { projectId } }));
      toast.success("Projekat troška je uspešno izmenjen.");
    } catch (err) {
      console.error("Error updating expense project:", err);
    }
  }, 1000);

  return (
    <div className="row" onClick={() => dispatch(setSelectedIndex(index))}>
      <div className="col right">
        <input type="checkbox" />
      </div>
      <div className="col strong">
        <div className="bg-item">
          <input
            defaultValue={expense.title}
            onChange={(e) => { onChangeTitle(expense.expenseId, e.target.value) }} />
        </div>
      </div>
      <div className="col">
        {false && (
          <span onClick={e => {
            e.stopPropagation();
            dispatch(setDeleteExpenseModalOpen({ visible: true, index }))
          }}>
            <CancelIcon
              style={{ cursor: "pointer", fontSize: 15, color: grey[300] }}
            />
          </span>
        )}
      </div>
      <div className="col">
        <div className="bg-item center">
          {expense.project.active
            ? <ProjectSelect
              customStyles={styles.rowInMainTable}
              onChange={handleProjectChange}
              defaultValue={expense.project.projectId}
              isClearable={false}
              options={projects}
            />
            : <input type="text" style={{ fontSize: "10px" }}
              className="bg-item-dark" value={expense.project.name}
              readOnly />}
        </div>
      </div>
      <div className="col">
        <div className="bg-item-border-light center">
          <span className="light">{FormatDate(expense.date)}</span>
        </div>
      </div>
      <div className="col">
        <div className="bg-item-border-light center">
          <span className="light">
            {expense.latestPaymentDate && FormatDate(expense.latestPaymentDate)}
          </span>
        </div>
      </div>
      <div className="col strong">
        <div className="bg-item center">
          <span>{expense.totalAmountPaid + " rsd"}</span>
        </div>
      </div>
    </div>
  );
};

export default TableRow;
